import { render } from "./PlatformSubscriptionPayChargeModal.vue?vue&type=template&id=23f0fa67"
import script from "./PlatformSubscriptionPayChargeModal.vue?vue&type=script&lang=js"
export * from "./PlatformSubscriptionPayChargeModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__